import React from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

import Styles from "../../../scss/qrCode.module.scss";
import { ReactComponent as Circle } from "../../../assets/images/icon-info-circle.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "1rem",
    padding: "2rem",
  },
  text: {
    "fontFamily": "Open Sans",
    "fontStyle": "normal",
    "fontWeight": 600,
    "fontSize": "1.0714rem",
    "lineHeight": "1.4285rem",

    [theme.breakpoints.down("xl")]: {
      /* "fontSize": "0.8571rem", */
      "fontSize": "1rem",
    }
  }
}));

const QrMaterials = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid 
      container 
      item 
      className={`${Styles.material} ${classes.root}`}
      direction="column"
      xl={4}
      lg={6}
    >
      <Grid item >
        <p className={classes.text}>
          <Circle style={{ marginRight: ".5rem" }} />
          {t("qrCode.materialsTitle")}
        </p>
      </Grid>

      <Grid item>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.yoello.com/yoello-store"
          >
            {t("qrCode.materialsButton")}
          </a>
      </Grid>
    </Grid>
  );
};

export default QrMaterials;
